import api from "../../../../lib/api";
import { IEditVasRulePayload, IVasRuleCreate, IVasRuleListSearch } from "../../../../types/master/vasRuleInterface";

export const createVasRuleApi = async (data: IVasRuleCreate) => {
  return await api.post("/vas-rules/", data);
};

export const getVasRuleListApi = async (data: IVasRuleListSearch) => {
  return await api.get(`/vas-rules/${data.page}/${data?.pageLimit ?? 10}`, {
    params: {
      search: data?.search ?? "",
      vas_type_id: data?.vas_type_id ?? "",
      rate_basis_id: data?.rate_basis_id ?? "",
    },
  });
};

export const getVasRuleDataByIdApi = async (id: number | string) => {
  return await api.get(`/vas-rules/id/${id}`);
};

export const editVasRuleDataByIdApi = async (payload: IEditVasRulePayload) => {
  return await api.put(`/vas-rules/id/${payload.id}`, payload.data);
};

export const getVasTypeDropdownApi = async (data?: { page?: number; search?: string }) => {
  return await api.get("/dropdowns/vas-types/0/10", {
    params: { search: data?.search ?? "" },
  });
};

export const getVasRateBasisDropdownApi = async (data?: { page?: number; search?: string }) => {
  return await api.get("/dropdowns/vas-rate-basis/0/10", {
    params: { search: data?.search ?? "" },
  });
};
